import globalStyles from './css/global.css';
import shadowGlobalStyles from './css/shadow-global.css';

import { createLinkHtmlElement } from './util';

type ShadowDomStyleOptions = {
  shadowRoot: ShadowRoot;
  hotelId: string;
  additonalStyles?: any[];
};

export function setupShadowDomStyle({
  shadowRoot,
  hotelId,
  additonalStyles = [],
}: ShadowDomStyleOptions) {
  if (process.env.NODE_ENV === 'development') {
    const themeLink = createLinkHtmlElement(
      `http://localhost:1337/hotels/theme?resource=widget&hotelId=${hotelId}`
    );
    shadowRoot.appendChild(themeLink);
  } else {
    const themeLink = createLinkHtmlElement(
      `https://api.concierge-hotel.com/hotels/theme?resource=widget&hotelId=${hotelId}`
    );
    shadowRoot.appendChild(themeLink);
  }

  const fontFamilyLink = createLinkHtmlElement('https://use.typekit.net/tyu3jgi.css');
  document.head.appendChild(fontFamilyLink);

  (globalStyles as any).use({ target: shadowRoot });
  (shadowGlobalStyles as any).use({ target: shadowRoot });

  additonalStyles.forEach((style) => {
    style.use({ target: shadowRoot });
  });

  return shadowRoot;
}
